// @flow
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'array.prototype.fill'

import React from 'react'
import ReactDOM from 'react-dom'

import ErrorBoundaries from '@modules/bugsnag'
import setApiKey from './master/apiKey'
import './master/i18n'
import App from './App'

setApiKey()

const root: any = document.getElementById('root')

ReactDOM.render(
  <ErrorBoundaries apiKey='a56b951548eff1ac11eeb0aed8e0b8db'>
    <App />
  </ErrorBoundaries>,
  root
)
